export const bgUtil = imageName =>
  `https://amdrewards-newqa.s3.us-east-2.amazonaws.com/logo/${imageName}`

export const combinePromotionsById = (array1, array2) => {
  const idSet = new Set(array1.map(obj => obj.id))

  array2.forEach(obj => {
    if (idSet.has(obj.id)) {
      // Find the index of the object with the matching id in array1
      const indexToUpdate = array1.findIndex(item => item.id === obj.id)

      if (indexToUpdate !== -1) {
        // Merge properties into the existing object in array1
        Object.assign(array1[indexToUpdate], obj)
      }
    }
  })

  return array1
}
